export default __webpack_public_path__ + "static/media/tripple_panna.4737bb4c.png";